import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b0c40c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-editor-container" }
const _hoisted_2 = { class: "real-time" }
const _hoisted_3 = { class: "wrapper-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "chart-span" }, "交易数据", -1))
const _hoisted_5 = { class: "el-dropdown-link" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15px",
  viewBox: "0 0 1024 1024",
  "data-v-394d1fd8": ""
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M831.872 340.864 512 652.672 192.128 340.864a30.592 30.592 0 0 0-42.752 0 29.12 29.12 0 0 0 0 41.6L489.664 714.24a32 32 0 0 0 44.672 0l340.288-331.712a29.12 29.12 0 0 0 0-41.728 30.592 30.592 0 0 0-42.752 0z"
  })
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wrapper-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "chart-span" }, "资产概况")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_PanelGroup = _resolveComponent("PanelGroup")!
  const _component_AssetOverview = _resolveComponent("AssetOverview")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, "实时数据 " + _toDisplayString($setup.dayjs().format('HH:mm:ss')), 1),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_el_dropdown, { onCommand: $setup.changeCurrency }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moneyOptions, (item) => {
                return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                  command: item,
                  key: item
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item?.text), 1)
                  ]),
                  _: 2
                }, 1032, ["command"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(_ctx.currency), 1),
            _hoisted_6
          ])
        ]),
        _: 1
      }, 8, ["onCommand"])
    ]),
    _createVNode(_component_PanelGroup, {
      list: $setup.fundList,
      summaryList: $setup.summaryList,
      loading: $setup.loading
    }, null, 8, ["list", "summaryList", "loading"]),
    _hoisted_7,
    _createVNode(_component_AssetOverview, {
      lpoaPositionListData: $setup.lpoaPositionListData,
      lpoaFundInfoListData: $setup.lpoaFundInfoListData,
      accList: $setup.accList
    }, null, 8, ["lpoaPositionListData", "lpoaFundInfoListData", "accList"])
  ]))
}